import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-8">
            {aboutData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center mb-10">
            {aboutData.content}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
            {aboutData.stats.map((stat, i) => (
              <div key={i} className="text-center p-5 bg-background-100 rounded-lg">
                <div className="text-2xl md:text-3xl font-bold font-heading text-accent-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}